import { render, staticRenderFns } from "./IconSplit.vue?vue&type=template&id=533b181e&scoped=true&"
import script from "./IconSplit.vue?vue&type=script&lang=js&"
export * from "./IconSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b181e",
  null
  
)

export default component.exports